import RetailApiV2 from '@/api/retailApi/RetailApiV2'

export interface SearchProductImage {
  id: number
  alt: string | null
  main_image: boolean
  data: Record<string, {
    formats: Record<string, string>
    height: number
    width: number
  }>
}

export interface SearchProduct {
  id: number
  name: string
  permalink: string
  price: string
  currency: string
  images: SearchProductImage[]
  state: string
  isPresale: boolean
}

export interface SearchCategory {
  id: number
  parentId: number
  title: string
  permalink: string
  systemName: string
  iconUrl: string
  image: string
}

export interface SearchArticle {
  id: number
  title: string
  permalink: string
  perex: string
  hasPadding: boolean
  image: Record<string, { formats: Record<string, string>; height: number; width: number }>
  tags: { systemName: string; name: string }[]
}

interface SearchResponse {
  products: SearchProduct[]
  categories: SearchCategory[]
}

interface SearchArticlesResponse {
  articles: SearchArticle[]
}

interface TopSearchesResponse {
  mostSearched: string[]
}

interface CrossSellResponse {
  cross_sell_products: SearchProduct[]
}

export class SearchService {
  async loadCrossSellProducts(limit = 5): Promise<SearchProduct[]> {
    const { data } = await RetailApiV2.get(`cross_sell_products?quantity=${limit}&kind=search_cross_sell`) as { data: CrossSellResponse }
    return data?.cross_sell_products ?? []
  }

  async search(q: string, limit = 5): Promise<SearchResponse> {
    const { data } = await RetailApiV2.get(`search?q=${encodeURIComponent(q)}&limit=${limit}`) as { data: SearchResponse }
    return { products: data?.products ?? [], categories: data?.categories ?? [] }
  }

  async searchArticles(q: string, limit = 4): Promise<SearchArticle[]> {
    const { data } = await RetailApiV2.get(`search/articles?q=${encodeURIComponent(q)}&limit=${limit}`) as { data: SearchArticlesResponse }
    return data?.articles ?? []
  }

  async loadTopSearches(limit = 16): Promise<string[]> {
    const { data } = await RetailApiV2.get(`search/top_searches?limit=${limit}&cleaned=true`) as { data: TopSearchesResponse }
    return data?.mostSearched ?? []
  }
}

export const searchService = new SearchService()
